var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocumentsZero(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "documents_zero",
    "data-name": "documents zero",
    transform: "translate(-134.472 -131.116)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_",
    "data-name": "<Group>",
    transform: "translate(124.831 87.332)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38724",
    "data-name": "Group 38724",
    transform: "translate(24.644 60.23)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1235",
    "data-name": "Ellipse 1235",
    cx: 50,
    cy: 50,
    r: 50,
    transform: "translate(-15.003 -16.446)",
    fill: "#a4a9b0",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1154",
    "data-name": "Ellipse 1154",
    cx: 35,
    cy: 35,
    r: 35,
    transform: "translate(-0.003 -1.447)",
    fill: "#a4a9b0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "news",
    transform: "translate(9 7.556)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28813",
    "data-name": "Path 28813",
    d: "M42.257,17.869H37.084V9.739A.739.739,0,0,0,36.345,9H9.739A.739.739,0,0,0,9,9.739V39.3A3.7,3.7,0,0,0,12.7,43H39.3A3.7,3.7,0,0,0,43,39.3V18.608A.739.739,0,0,0,42.257,17.869ZM12.7,41.518A2.22,2.22,0,0,1,10.478,39.3V10.478H35.606V39.3a3.68,3.68,0,0,0,.741,2.217ZM41.518,39.3a2.217,2.217,0,1,1-4.434,0V19.347h4.434Z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28814",
    "data-name": "Path 28814",
    d: "M32.52,17H17.739a.739.739,0,0,0-.739.739v5.912a.739.739,0,0,0,.739.739H32.52a.739.739,0,0,0,.739-.739V17.739A.739.739,0,0,0,32.52,17Zm-.739,5.912h-13.3V18.478h13.3Z",
    transform: "translate(-2.088 -2.088)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28815",
    "data-name": "Path 28815",
    d: "M32.52,33H17.739a.739.739,0,0,0,0,1.478H32.52a.739.739,0,1,0,0-1.478Z",
    transform: "translate(-2.088 -6.263)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28816",
    "data-name": "Path 28816",
    d: "M32.52,39H17.739a.739.739,0,0,0,0,1.478H32.52a.739.739,0,1,0,0-1.478Z",
    transform: "translate(-2.088 -7.829)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28817",
    "data-name": "Path 28817",
    d: "M32.52,45H17.739a.739.739,0,0,0,0,1.478H32.52a.739.739,0,1,0,0-1.478Z",
    transform: "translate(-2.088 -9.394)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentsZero);
export default __webpack_public_path__ + "static/media/documents-zero.d1e4120de7c8a5ec6920698f7e549893.svg";
export { ForwardRef as ReactComponent };